export default __webpack_public_path__ + "static/media/attachments-blue-icon.27807d70.svg";